import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Esto realmente funciona en 24 horas?',
  answer: 'Sí. La mayoría de los hombres experimentan su primera victoria (reducción significativa de impulsos) dentro del primer día. Los resultados completos toman 7-30 días dependiendo de tu historial.'
}, {
  question: '¿Necesito tener conocimientos técnicos?',
  answer: 'No. El sistema está diseñado para hombres ocupados. Si puedes seguir instrucciones simples, puedes implementar el Protocolo de Blindaje.'
}, {
  question: '¿Es esto religioso o espiritual?',
  answer: 'No. Es un método basado en neurociencia e ingeniería conductual. Funciona sin importar tus creencias personales.'
}, {
  question: '¿Qué pasa si no funciona para mí?',
  answer: 'Tienes 7 días de garantía de hierro. Si no recuperas tu energía y coherencia desde la primera noche, te devolvemos cada centavo. Sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  function toggle(index: number) {
    setOpenIndex(openIndex === index ? null : index);
  }
  return <section className="py-12 px-4 bg-deep-black border-t border-card-border" data-id="element-60">
      <div className="max-w-3xl mx-auto" data-id="element-61">
        <h2 className="font-bebas text-4xl md:text-6xl text-white text-center mb-16" data-id="element-62">
          PREGUNTAS <span className="text-cyan-neon" data-id="element-63">FRECUENTES</span>
        </h2>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, index) => <div key={index} className="border border-card-border rounded-xl overflow-hidden bg-card-dark" data-id="element-65">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-5 text-left group" data-id="element-66">
                <span className="font-bebas text-xl md:text-2xl text-white tracking-wide group-hover:text-cyan-neon transition-colors" data-id="element-67">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-cyan-neon shrink-0 ml-4 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-69">
                <p className="px-6 pb-6 font-inter text-base text-text-muted leading-relaxed" data-id="element-70">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}